/* tslint:disable */

/**
 */
export class EquipSizingParam {
    width?: number;
    length?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-sizing-param.ts